export default {
    _prefix: "ActionIcons",
    delete: "Delete",
    add: "Add",
    edit: "Edit",
    up: "Move up",
    down: "Move down",
};
